import { Exclude, Expose, Transform } from "class-transformer";
import { IsDefined, IsNumber, IsOptional, Max, Min } from "class-validator";

export const SCORE_CONFIG = {
    feedbacksAverage: {
        min: 1,
        max: 5,
    },
};

@Exclude()
export class Score {
    @IsNumber()
    @IsDefined()
    @Expose()
    @Transform((totalScore) => (totalScore >= 0 ? totalScore : 5))
    public totalScore: number = 5;

    @IsNumber()
    @Min(SCORE_CONFIG.feedbacksAverage.min)
    @Max(SCORE_CONFIG.feedbacksAverage.max)
    @IsOptional()
    @Expose()
    public feedbacksAverage?: number;

    // The trip is declined/accepted ( for example 4 ): 5 of 100 is declined = score is 95%
    @IsNumber()
    @Expose()
    public acceptanceScoreAverage: number = 5;

    // for ex. the penalty is 40EUR and trip cost is 200EUR, the penalty score 80% = 0.8 = 4stars
    @IsNumber()
    @Expose()
    public penaltyScoreAverage: number = 5;
}
